export enum OfferAvailability {
  OFFERS_AVAILABLE = "OFFERS_AVAILABLE",
  OTHER_AVAILABLE = "OTHER_AVAILABLE",
  DELIVER_ALTERNATE = "DELIVER_ALTERNATE",
  OTHER_DELIVER_ALTERNATE = "OTHER_DELIVER_ALTERNATE",
  UNDELIVERABLE = "UNDELIVERABLE",
  ERROR = "ERROR",
  // no behaviour difference to ERROR, just distinguish and log
  ERROR_OTHER_AVAILABLE = "ERROR_OTHER_AVAILABLE",
}

export type OfferAvailabilityByProductType = {
  exchange: OfferAvailability;
  refill: OfferAvailability;
};
